import {invoicesStatusMap} from 'constants/InvoicesConstants';
import {
  INVOICES_ALL,
  INVOICES_ALL_SUCCESS,
  INVOICES_CREATE,
  INVOICES_CREATE_SUCCESS,
  INVOICES_DELETE,
  INVOICES_DELETE_SUCCESS,
  INVOICES_GET,
  INVOICES_GET_ACCESS_CODE,
  INVOICES_GET_ACCESS_CODE_SUCCESS,
  INVOICES_GET_ALL,
  INVOICES_GET_ALL_SUCCESS,
  INVOICES_GET_LAST,
  INVOICES_GET_LAST_SUCCESS,
  INVOICES_GET_SUCCESS,
  INVOICES_SET_BOARD_COLUMNS,
  INVOICES_SET_BOARD_DATA,
  INVOICES_SET_BOARD_ORDERED,
  INVOICES_SET_MODIFIED_INVOICE,
  INVOICES_STATUSES_SUCCESS,
  INVOICES_UPDATE,
  INVOICES_UPDATE_PAGINATION,
  INVOICES_UPDATE_SUCCESS,
} from '../constants/Invoices';

const initialState = {
  invoice: {
    id: null,
    name: '',
    color: '',
  },
  invoices: null,
  perPage: 10,
  from: 0,
  to: 0,
  page: 1,
  boardInvoices: {
    invoices: null,
    boardData: {
      ordered: [],
      columns: {},
    },
    modifiedInvoice: null,
    total: 0,
  },
  statuses: null,
  loading: false,
};

const invoices = (state = initialState, action) => {
  switch (action.type) {
    case INVOICES_ALL:
      return {
        ...state,
        perPage: action.perPage,
        page: action.page,
        loading: true,
      };
    case INVOICES_ALL_SUCCESS:
      return {
        ...state,
        invoices: action.invoices,
        total: action.total,
        from: action.from,
        to: action.to,
        loading: false,
      };
    case INVOICES_GET:
      return {
        ...state,
        loading: true,
      };
    case INVOICES_GET_ACCESS_CODE:
      return {
        ...state,
        loading: true,
      };
    case INVOICES_GET_ALL:
      return {
        ...state,
        loading: true,
      };
    case INVOICES_GET_ALL_SUCCESS:
      return {
        ...state,
        boardInvoices: {
          ...state.boardInvoices,
          invoices: action.invoices,
          total: action.total,
        },
        loading: false,
      };
    case INVOICES_GET_LAST:
      return {
        ...state,
        loading: true,
      };
    case INVOICES_GET_LAST_SUCCESS:
      return {
        ...state,
        dashboardInvoices: action.invoices,
        loading: false,
      };
    case INVOICES_SET_BOARD_DATA:
      return {
        ...state,
        boardInvoices: {
          ...state.boardInvoices,
          boardData: {
            ordered: action.ordered,
            columns: action.columns,
          },
        },
      };
    case INVOICES_SET_BOARD_ORDERED:
      return {
        ...state,
        boardInvoices: {
          ...state.boardInvoices,
          boardData: {
            ordered: action.ordered,
            columns: state.boardInvoices.boardData.columns,
          },
        },
      };
    case INVOICES_SET_BOARD_COLUMNS:
      return {
        ...state,
        boardInvoices: {
          ...state.boardInvoices,
          boardData: {
            ordered: state.boardInvoices.boardData.ordered,
            columns: action.columns,
          },
        },
      };
    case INVOICES_SET_MODIFIED_INVOICE:
      return {
        ...state,
        boardInvoices: {
          ...state.boardInvoices,
          modifiedInvoice: action.invoice,
        },
      };
    case INVOICES_GET_SUCCESS:
      return {
        ...state,
        invoice: action.invoice,
      };
    case INVOICES_GET_ACCESS_CODE_SUCCESS:
      return {
        ...state,
        invoice: action.invoice,
      };
    case INVOICES_CREATE:
      return {
        ...state,
        loading: true,
      };
    case INVOICES_CREATE_SUCCESS:
      return {
        ...state,
        invoices: [...(state.invoices ? state.invoices : []), action.invoice],
        loading: false,
      };
    case INVOICES_UPDATE:
      return {
        ...state,
        loading: true,
      };
    case INVOICES_UPDATE_SUCCESS:
      let boardInvoices = { ...state.boardInvoices };

      if (state.boardInvoices.modifiedInvoice) {
        boardInvoices.boardData.columns[
          invoicesStatusMap[action.invoice.status.id]
        ] = boardInvoices.boardData.columns[
          invoicesStatusMap[action.invoice.status.id]
        ].map((i) =>
          i.id === action.invoice.id
            ? { ...i, status: action.invoice.status }
            : i
        );
      }

      return {
        ...state,
        invoice: action.invoice,
        invoices:
          state.invoices &&
          state.invoices.map((t) => {
            if (action.invoice.id === t.id) {
              return action.invoice;
            }
            return t;
          }),
        boardInvoices,
        loading: false,
      };
    case INVOICES_UPDATE_PAGINATION:
      return {
        ...state,
        perPage: action.perPage,
        page: action.page,
      };
    case INVOICES_DELETE:
      return {
        ...state,
        loading: true,
      };
    case INVOICES_DELETE_SUCCESS:
      return {
        ...state,
        invoices: state.invoices
          ? state.invoices.filter((t) => t.id !== action.id)
          : [],
        loading: false,
      };
    case INVOICES_STATUSES_SUCCESS:
      return {
        ...state,
        statuses: action.statuses,
        loading: false,
      };
    default:
      return state;
  }
};

export default invoices;
